import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { canvasActions } from "../store/canvasSlice";
import { editorActions } from "../store/editorSlice";

export const useKeyboardShortcuts = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (
				e.target instanceof HTMLInputElement ||
				e.target instanceof HTMLTextAreaElement
			) {
				return;
			}

			const isCtrlOrMeta = e.ctrlKey || e.metaKey;
			const key = e.key.toLowerCase();

			if (isCtrlOrMeta) {
				switch (key) {
					case "z":
						if (e.shiftKey) {
							dispatch(canvasActions.redo());
						} else {
							dispatch(canvasActions.undo());
						}
						e.preventDefault();
						break;
					case "y":
						dispatch(canvasActions.redo());
						e.preventDefault();
						break;
					case "s":
						dispatch(canvasActions.saveToLocalStorage());
						dispatch(editorActions.saveToLocalStorage());
						e.preventDefault();
						break;
				}
				return;
			}

			switch (key) {
				case "d":
					dispatch(canvasActions.setMode("draw"));
					break;
				case "s":
					if (!isCtrlOrMeta) {
						dispatch(canvasActions.setMode("select"));
					}
					break;
				case "e":
					dispatch(canvasActions.setMode("eraseVertices"));
					break;
				case "f":
					dispatch(canvasActions.setMode("eraseFaces"));
					break;
				case "delete":
				case "backspace":
					dispatch(canvasActions.deleteSelectedPoints());
					break;
				case "r":
					dispatch(canvasActions.randomize());
					break;
				case "c":
					if (!isCtrlOrMeta) {
						dispatch(canvasActions.clearPoints());
					}
					break;
				case "1":
					dispatch(canvasActions.setView("gradient"));
					break;
				case "2":
					dispatch(canvasActions.setView("lines"));
					break;
				case "3":
					dispatch(canvasActions.setView("dots"));
					break;
				case "t":
					dispatch(editorActions.invertTheme());
					break;
				case "v":
					dispatch(canvasActions.toggleShowVertices());
					break;
			}
		};

		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [dispatch]);
};
